module.exports = __webpack_public_path__ + "img/lzd_lord_mazdamundi_0.b55f29d0.png";